import React, { Fragment } from 'react'
import styled from 'styled-components'
import ItemArticle from '../../../../../Article/components/ItemArticle'
import PropTypes from 'prop-types'
import moment from 'moment'
import Text from '../../../../../../components/Text'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Title from '../../../../../../components/Title'
import ContainerFull from '../../../../../../components/ContainerFull'

const Wrapper = styled(ContainerFull)``

const StyledNewstickerTable = styled.table`
  border-collapse: collapse;
  width: 100%;
`

const StyledTableRow = styled.tr`
  background-color: #f6f6f6;
  &:nth-of-type(odd) {
    background-color: #fcfcfc;
  }
`

const StyledBorderedCell = styled.td`
  border-top: 1px solid rgb(224, 224, 224);
`

const StyledNewsDot = styled.span`
  color: ${(props) => props.theme.color.stol};
  font-size: 16px;
  font-weight: bold;
`

const DateText = styled(Text)`
  width: 35px;
  white-space: nowrap;
`
const StyledTitle = styled(Title)`
  margin: 8px;
`

const styleTableCell = {
  padding: 8,
}

const dateTitleFormat = 'dddd, DD.MM.YYYY'

const ListArticle = ({ articles, ...props }) => {
  let titleDate = null

  const TitleDateRow = ({ articleDate }) => {
    return (
      <tr>
        <td key="XY" colSpan={2}>
          <StyledTitle>{articleDate}</StyledTitle>
        </td>
      </tr>
    )
  }

  let articlesPerDate = {}
  articles.forEach((article) => {
    const articleDate = moment(article.date).format(dateTitleFormat)
    if (!articlesPerDate[articleDate]) {
      articlesPerDate[articleDate] = []
    }
    articlesPerDate[articleDate].push(article)
  })

  return (
    <Wrapper {...props}>
      <StyledNewstickerTable>
        {Object.keys(articlesPerDate).map((articleDate) => {
          return (
            <>
              <TitleDateRow articleDate={articleDate} key={articleDate} />
              {articlesPerDate[articleDate].map((articlePerDate) => (
                <>
                  <StyledTableRow key={articlePerDate.id}>
                    <StyledBorderedCell style={styleTableCell}>
                      <DateText>
                        {moment(articlePerDate.date).format('HH:mm').toString()}{' '}
                        {articlePerDate.new && <StyledNewsDot>&bull;</StyledNewsDot>}
                      </DateText>
                    </StyledBorderedCell>
                    <StyledBorderedCell style={styleTableCell}>
                      <ItemArticle view="line" hide={['description']} article={articlePerDate} />
                    </StyledBorderedCell>
                  </StyledTableRow>
                </>
              ))}
            </>
          )
        })}
      </StyledNewstickerTable>
    </Wrapper>
  )
}

ListArticle.propTypes = {
  articles: PropTypes.arrayOf(ItemArticle.propTypes),
}

export default ListArticle
export { Wrapper as Wrapper0ListArticle, StyledTableRow as StyledTableRow0ListArticle }
